import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ActiveStatus } from '../../../../components';
import {
  getWebhookEvents,
  getWebhookSettings,
} from '../../../../store/org/org.actions';
import { RootState } from '../../../../store/store';
import { Toggle } from '../Toggle/Toggle';
import { webhookPrevievImg } from './assets';
import { errTriangle } from './components/AuthParamsRow/assets';
import { WebhooksForm } from './components/FormSection/WebhooksForm';

export const Webhooks: React.FC = (): JSX.Element => {
  const { user } = useSelector((state: RootState) => state.auth);
  const { myOrg, webhook } = useSelector((state: RootState) => state.org);

  const [formSectionOpen, setFormSectionOpen] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (user) {
      dispatch(getWebhookEvents(user.orgId, user.userId));
      dispatch(getWebhookSettings(user.orgId));
    } // eslint-disable-next-line
  }, []);

  const toggleFormSection = () => {
    setFormSectionOpen(!formSectionOpen);
  };

  const settingsClick = () => {
    toggleFormSection();
  };

  const attrs = {
    wrapper: {
      className: `${formSectionOpen ? 'open-form' : ''} webhook`,
    },

    body: {
      wrapper: {
        className: 'webhook__body',
      },

      preview: {
        wrapper: {
          className: 'webhook__body__preview',
        },

        centerImg: {
          className: 'webhook__body__preview-centered-img',
          src: webhookPrevievImg,
        },
      },

      info: {
        wrapper: {
          className: 'webhook__body__info',
        },

        title: {
          wrapper: {
            className: 'webhook__body__info__title',
          },

          label: {
            className: 'webhook__body__info__title-label',
          },

          activeElement: {
            wrapper: {
              className: 'webhook__body__info__title__active-element',
            },

            error: {
              wrapper: {
                className: 'webhook__body__info__title__active-element__error',
              },

              icon: {
                src: errTriangle,
                className:
                  'webhook__body__info__title__active-element__error-icon',
              },

              tooltip: {
                className:
                  'webhook__body__info__title__active-element__error-tooltip',
              },
            },

            textForDealMaker: {
              className: 'webhook__body__info__title__active-element-text',
            },

            settings: {
              className: `${
                formSectionOpen ? 'open' : ''
              } webhook__body__info__title__active-element-button`,
              onClick: settingsClick,
            },
          },
        },

        content: {
          wrapper: {
            className: 'webhook__body__info__content',
          },

          text: {
            className: 'webhook__body__info__content-text',
          },
        },
      },
    },

    footer: {
      wrapper: {
        className: 'webhook__footer',
      },
    },
  };

  const title = 'Webhooks';

  const text =
    'Create webhooks for trigger events to easily connect Substrata to your CRM, email and more.';

  // const status = defaultActive ? 'active' : 'inactive';

  const errorTooltipMessage = `Connection ${
    webhook.status.updateFailed
      ? 'failed'
      : `${webhook.settings.isDisabledByError ? 'lost' : <></>}`
  }.\n Open 'Settings' for more details.`;

  const errorIcon =
    webhook.status.updateFailed ||
    webhook.status.connectionLost ||
    webhook.settings.isDisabledByError ? (
      <div {...attrs.body.info.title.activeElement.error.wrapper}>
        <img {...attrs.body.info.title.activeElement.error.icon} alt="" />
        <div {...attrs.body.info.title.activeElement.error.tooltip}>
          {errorTooltipMessage}
        </div>
      </div>
    ) : null;

  const isWebhookActive = myOrg?.enabledFeatures?.includes('webhooks') || false;

  const toggleOrStatus =
    user?.role !== 'dealmaker' ? (
      <Toggle
        serviceName="Webhook"
        defaultActive={isWebhookActive}
        disabled={false}
        appName="webhooks"
      />
    ) : (
      <ActiveStatus
        status={isWebhookActive ? 'active' : 'inactive'}
        className="webhook__body__info__title-status"
      />
    );

  const contactUsOrText =
    user?.role === 'dealmaker' ? (
      <div {...attrs.body.info.title.activeElement.textForDealMaker}>
        Dealmaker
      </div>
    ) : (
      <div {...attrs.body.info.title.activeElement.settings}>Settings</div>
    );

  const conditionalTitleActiveItem = (
    <>
      {errorIcon} {contactUsOrText} {toggleOrStatus}
    </>
  );

  return (
    <>
      <div {...attrs.wrapper}>
        <div {...attrs.body.wrapper}>
          <div {...attrs.body.preview.wrapper}>
            <img {...attrs.body.preview.centerImg} alt="" />
          </div>
          <div {...attrs.body.info.wrapper}>
            <div {...attrs.body.info.title.wrapper}>
              <div {...attrs.body.info.title.label}>{title}</div>
              <div {...attrs.body.info.title.activeElement.wrapper}>
                {conditionalTitleActiveItem}
              </div>
            </div>
            <div {...attrs.body.info.content.wrapper}>
              <div {...attrs.body.info.content.text}>{text}</div>
            </div>
          </div>
        </div>
      </div>
      <WebhooksForm
        isOpen={formSectionOpen}
        isWebhookFeatureActive={isWebhookActive}
      />
    </>
  );
};
